import { queryClient, useMutation } from 'query';
import { deleteVideo } from '../../services';
import { getVideoDetailQueryKey, getVideosQueryKey } from '../keys';

export const useDeleteVideo = () =>
  useMutation<unknown, { videoId: string }>({
    async mutationFn({ videoId }) {
      await deleteVideo({ videoId });
    },
    async onSuccess(_, { videoId }) {
      await queryClient.invalidateQueries({ queryKey: getVideosQueryKey({}) });
      queryClient.removeQueries({ queryKey: getVideoDetailQueryKey({ videoId }) });
    },
  });
